import {get, post, put,Delete} from '../axios'


// 增值服务说明-查看
export const showView = params => get('/web/service/show/view');

// 增值服务说明-修改
export const showUpdate = params => put(`/web/service/show/update`,params);